import { useSelector } from 'react-redux';
import { RootState } from 'src/services';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import CoverImage from '../CoverImage';
import VendorLogo from '../VendorLogo';

type VendorProfileType = {
  mobileDevice: boolean;
  logo: any;
  coverImage: any;
  templateId: number;
};

export default function VendorProfile(props: VendorProfileType) {
  const { mobileDevice, logo, coverImage, templateId } = props;
  const vendorName = useSelector<RootState, []>((state) => state.auth.user?.vendor?.title);
  const vendorScore = useSelector<RootState, []>((state) => state.auth.user?.vendor?.vendorScore);
  if (!logo?.status && !coverImage?.status) return null;
  return (
    <>
      <div className="d-flex px-6 flex-column gap-2">
        {/* CoverImage */}
        <CoverImage mobileDevice={mobileDevice} coverImage={coverImage} templateId={templateId} />
        {/* CoverImage */}
        <div className={`d-flex justify-content-between ${mobileDevice ? 'flex-column' : 'flex-row'}`}>
          <div className="d-flex gap-4">
            {/* Logo */}
            <VendorLogo mobileDevice={mobileDevice} logo={logo} templateId={templateId} />
            {/* Logo */}
            <div className="d-flex flex-column gap-2 flex-fill">
              <div className={`fw-bold ${mobileDevice ? 'fs-3' : 'fs-1'}`}>{vendorName}</div>
              <div className="d-flex gap-2 align-items-center">
                <span className="badge text-bg-success text-white">{vendorScore}</span>
                <div>9.999 Ürün</div>
              </div>
            </div>
          </div>
          <div className={`d-flex gap-2 mt-4 ${mobileDevice ? 'flex-row align-items-center' : 'flex-column align-items-center'}`}>
            <div>
              <img src={toAbsoluteUrl(`/media/showcasepage-images/${mobileDevice ? 'ide-follow-btn-mobile' : 'ide-follow-btn'}.png`)} alt="Idefix Button" />
            </div>
            <div>9.999 Takipçi</div>
          </div>
        </div>
        <div className="mt-5 d-flex w-100 align-items-center justify-content-center">
          <img src={toAbsoluteUrl(`/media/showcasepage-images/${mobileDevice ? 'ide-vendor-search-mobile' : 'ide-vendor-search'}.png`)} alt="Idefix Search Area" />
        </div>
      </div>
    </>
  );
}
